module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<header></header> <div class=\"panel filter-panel\"> <div id=\"api_mode_selector\" class=\"filter\"></div> <div id=\"request_report\" class=\"filter hidden-xs hidden-sm\"></div> </div> <div id=\"product_search\" class=\"panel\"></div> <div id=\"product_list\"></div> <div id=\"product_pagination\"></div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/fulfillment_products/template.ejs
// module id = 839
// module chunks = 1